import { motion } from 'framer-motion';
import React, { useRef } from 'react';
import { useClickAway } from 'react-use';
import { SideNavMode } from './SideNav';

export const SideNavWrapper = ({
  children,
  mode,
  isExpanded,
  setOpenSideBar,
  ...otherProps
}: {
  children: React.ReactNode;
  mode: SideNavMode;
  isExpanded?: boolean;
  setOpenSideBar: (value: boolean) => void;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  const ref = useRef<HTMLDivElement>(null);
  useClickAway(ref, () => {
    if (mode === 'auto') {
      setOpenSideBar(false);
    }
  });

  return (
    <div
      className={
        // NOTE needed for safari fix, as main container doesn't know the min width on safari
        `${mode === 'auto' ? 'min-w-[56px]' : ''} bg-opacity-0 relative z-99 flex h-screen max-h-[calc(100vh-48px)] flex-shrink-0`
      }
      {...otherProps}
    >
      <motion.nav
        ref={ref}
        animate={{
          width: mode === 'expanded' || isExpanded ? 230 : 56,
        }}
        transition={{
          duration: 0.14,
        }}
        className={`${
          mode === 'auto'
            ? `transition-duration-150 fixed top-[48px] transition-all ease-out`
            : 'sticky'
        } z-[99] flex h-full max-h-[calc(100vh-48px)] text-center lg:mt-0 lg:max-w-none`}
      >
        {children}
      </motion.nav>
    </div>
  );
};
